import * as React from 'react';
import { stringify } from 'qs';

import { FiltersSearchButton } from '../../components/FiltersSearchButton';
import { useSearchText, useDealType, useSpecialistType, useOfferType } from '../../hooks/selectors/searchRealtors';
import { trackFindClick } from './tracking';

export const SearchRealtorsButtonsContainer: React.FC = () => {
  const searchText = useSearchText(null);
  const dealType = useDealType();
  const specialistType = useSpecialistType();
  const offerType = useOfferType();

  const href = React.useMemo(() => {
    const queryString = stringify(
      {
        dealType,
        offerType,
        searchText,
      },
      { addQueryPrefix: true, skipNulls: true },
    );

    return `/${specialistType}/${queryString}`;
  }, [dealType, offerType, searchText, specialistType]);

  return (
    <FiltersSearchButton
      onClick={() => trackFindClick(href)}
      dataMark="FiltersSearchRealtorsButton"
      text="Найти"
      title="Найти"
      href={href}
    />
  );
};

SearchRealtorsButtonsContainer.displayName = 'SearchRealtorsButtonsContainer';
